export { NewsletterModule } from './NewsletterModule';
export { useNewsletterModuleDefaults } from './useNewsletterModuleDefaults';
